<div
  class="relative flex flex-col items-center justify-center w-full min-h-dvh bg-gradient-to-br from-sky-950 via-stone-950 to-slate-950 px-4"
>
  <p-toast key="global" position="top-center"></p-toast>

  <!-- Logos institucionales -->
  <div class="flex flex-row gap-2 absolute top-4 right-4 sm:top-6 sm:right-6 lg:top-10 lg:right-10 z-10">
    <img src="assets/img/stlucia-login-ayuntamiento.png" class="h-12 sm:h-16 lg:h-[100px]" />
    <img src="assets/img/stlucia-policia-login.png" class="h-12 sm:h-16 lg:h-[100px]" />
  </div>

  <!-- Card principal -->
  <div class="flex flex-col lg:flex-row w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-3xl xl:max-w-7xl
              min-h-[500px] lg:h-[560px] xl:h-[750px]
              items-stretch
              sm:bg-stone-950 rounded-xl sm:overflow-hidden
              sm:shadow-lg shadow-slate-800/90">

    <!-- Imagen lateral (solo visible en lg+) -->
    <img
      src="assets/img/image-stlucia.JPG"
      class="hidden lg:block w-1/2 object-cover flex-shrink-0"
      style="clip-path: inset(0 10px 0 0)"
    />

    <!-- Formulario -->
    <div class="flex flex-col items-start justify-start h-full w-full py-6 px-4 sm:px-8">

      <!-- PASO 1: Usuario y contraseña -->
      <div
        *ngIf="LoginStepOne == true && LoginStepTwo == false"
        class="relative z-50 flex flex-col items-center justify-start w-full"
      >
        <!-- Logos ADPOL -->
        <div class="flex flex-row items-center mt-2 gap-3 mb-1">
          <img src="assets/img/logo-adpol-new-2.png" class="h-16 sm:h-20 object-cover" />
          <img src="assets/img/logo-adpol-new.png" class="h-10 sm:h-14 object-fit" />
        </div>

        <p class="text-sm sm:text-base lg:text-lg w-full text-white pl-4 sm:pl-8 lg:pl-16 mb-1">
          "COMPROMISO, CONFIANZA Y CERCANÍA"
        </p>

        <div class="flex flex-row gap-2 text-white w-full items-center justify-start pl-4 sm:pl-8 lg:pl-16 text-3xl sm:text-4xl font-bold mb-2">
          <p>.</p><p>.</p><p>.</p><p>.</p><p>.</p>
        </div>

        <!-- Inputs -->
        <div class="flex flex-col w-full justify-center items-center gap-8 sm:gap-10 px-4 sm:px-8 lg:px-10 pt-4 pb-6">
          <p-floatlabel class="w-full">
            <label for="username" class="text-yellow-500 -ml-3">
              {{ 'login.solpol.text_1' | translate }}
            </label>
            <input
              pInputText
              type="text"
              [(ngModel)]="username"
              inputId="username"
              class="w-full"
            />
          </p-floatlabel>

          <p-floatlabel class="w-full">
            <p for="password" class="w-full text-yellow-500">
              {{ 'login.solpol.text_2' | translate }}
            </p>
            <p-password
              inputId="password"
              (keyup.enter)="loginOnKeyEnter()"
              [(ngModel)]="password"
              [toggleMask]="true"
              [disabled]="isLogging"
              fluid
            />
          </p-floatlabel>
        </div>
      </div>

      <!-- Spinner -->
      <p-progress-spinner
        [hidden]="!isLogging"
        strokeWidth="8"
        fill="transparent"
        animationDuration=".5s"
        [style]="{ width: '50px', height: '50px' }"
        class="my-2"
      />

      <!-- Botones Paso 1 -->
      <div
        *ngIf="LoginStepOne == true && LoginStepTwo == false"
        class="relative z-50 flex flex-col w-full px-4 sm:px-8 lg:px-10 gap-2 items-start"
      >
        <button
          pButton
          (click)="Login2FAStepOne()"
          [disabled]="isLogging"
          type="button"
          class="flex flex-col text-slate-200 font-semibold w-full bg-transparent items-start
                 border-0 border-b-4 border-slate-100 rounded-none
                 hover:bg-slate-100/90 hover:text-black
                 text-sm sm:text-base"
        >
          {{ 'login.solpol.text_0' | translate }}
        </button>

        <button
          pButton
          (click)="goToPasswordRecovery()"
          type="button"
          class="flex flex-col text-slate-200 font-semibold w-full bg-transparent items-start
                 border-0 border-b-4 border-yellow-300 rounded-none
                 hover:bg-yellow-100/90 hover:text-black
                 text-sm sm:text-base"
        >
          ¿Has olvidado tu contraseña?
        </button>

        <button
          pButton
          (click)="goToPasswordRecovery()"
          type="button"
          class="flex flex-col text-slate-200 font-semibold w-full bg-transparent items-start
                 border-0 border-b-4 border-sky-300 rounded-none
                 hover:bg-sky-100/90 hover:text-black
                 text-sm sm:text-base"
        >
          Manual de inicio de sesión
        </button>
      </div>

      <!-- PASO 2: Código 2FA -->
      <div
        *ngIf="LoginStepOne == false && LoginStepTwo == true"
        class="flex flex-col items-center px-4 sm:px-6 lg:px-8 mt-8 sm:mt-12 lg:mt-0 justify-between gap-6 sm:gap-8 w-full py-6 sm:py-8 lg:py-10"
      >
        <p class="text-xl sm:text-2xl font-bold text-white text-center">
          {{ 'login.solpol.text_3' | translate }}
        </p>

        <p-progress-bar
          [value]="progress"
          [style]="{
            width: '100%',
            height: '28px',
            backgroundColor: 'var(--p-surface-400)',
            color: 'red'
          }"
          showValue="false"
        ></p-progress-bar>

        <!-- Slots código OTP -->
        <div class="flex flex-row w-full justify-between gap-1 sm:gap-2">
          <input
            id="codeSlot1" [(ngModel)]="codeSlot1" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot1', 'codeSlot2')"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
          <input
            id="codeSlot2" [(ngModel)]="codeSlot2" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot2', 'codeSlot3')"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
          <input
            id="codeSlot3" [(ngModel)]="codeSlot3" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot3', 'codeSlot4')"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
          <input
            id="codeSlot4" [(ngModel)]="codeSlot4" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot4', 'codeSlot5')"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
          <input
            id="codeSlot5" [(ngModel)]="codeSlot5" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot5', 'codeSlot6')"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
          <input
            id="codeSlot6" [(ngModel)]="codeSlot6" type="text" maxlength="1"
            (input)="moveToNext($event, 'codeSlot6', null)"
            class="bg-neutral-200 rounded-xl sm:rounded-2xl text-3xl sm:text-4xl lg:text-5xl
                   w-10 h-14 sm:w-12 sm:h-16 lg:w-14 lg:h-20
                   text-center border border-neutral-400
                   focus:bg-(--p-primary-600) focus:text-neutral-100 flex-1"
          />
        </div>

        <p class="text-white text-sm sm:text-base text-center">
          {{ 'login.solpol.text_4' | translate }}
        </p>

        <button
          [disabled]="checkDisabledBtnSendCode()"
          pButton
          (click)="Login2FAStepTwo()"
          type="button"
          [label]="'login.solpol.label_1' | translate"
          class="w-full sm:w-auto"
        ></button>
      </div>

    </div>
  </div>
</div>

@if (isReloging) {
  <app-relogin-screen #reloginScreen *ngIf="isReloging" [logoUrl]="LogoReloging">
  </app-relogin-screen>
}
